import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import receiptModelApi from '~/services/receipt-model-api/receipt-model-api';

interface CancelTransferParams {
  reason: string;
  transferId: string;
}

export default function useCancelTransfer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CancelTransferParams) => receiptModelApi.cancelTransfer(params.transferId, params.reason),
    onError: (error: any) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.message;

      const errorMessages = {
        400: 'A ação não é permitida para o status atual da transferência.',
        401: 'Não autorizado. Faça login novamente.',
        403: 'Sem permissão para executar esta ação.',
        422: 'Motivo inválido. Verifique os dados informados.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || message
        || 'Erro inesperado ao cancelar transferência.';

      toast.error(errorMessage);
    },
    onSuccess: () => {
      toast.success('Transferência cancelada com sucesso.');
      queryClient.invalidateQueries({ queryKey: ['receipt-model'] });
    },
    retry: 3,
    retryDelay: 1000,
  });
}
